<template>
  <aside v-show="rol != 'client'" class="aside-menu">
    <div class="aside-wrapper">
      <div class="menu is-menu-main">
        <user-avatar>
          <div>
            <a
              @click="$router.push({ name: 'admin.settings' })"
              class="is-pink-dark has-text-weight-bold "
            >
              {{ $t('Perfil') }}
            </a>
          </div>
        </user-avatar>
        <aside-tools :isMainMenu="true" :hasCloseButton="false" />
        <aside-menu-container
          :menu-list="menu"
          :is-update-by-global-active-state="true"
          container-index-prefix="main"
          :hasTooltips="true"
          @menu-click="menuClick"
        >
        </aside-menu-container>

        <aside-menu-container
          :menu-list="menuBottom"
          :is-bottom="true"
          :is-update-by-global-active-state="true"
          container-index-prefix="bottom"
          :hasTooltips="true"
          @menu-click="menuClick"
        />
        <ul class="menu-list">
          <li>
            <a @click="logout()">
              <span class="icon"
                ><i class="mdi mdi-exit-to-app default"></i></span
              ><span class="menu-item-label">{{ $t('Cerrar sesión') }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div v-if="hasSecondary" class="menu is-menu-secondary">
        <aside-tools
          :icon="secondaryMenu.icon"
          :label="secondaryMenu.label"
          :updateMark="secondaryMenu.updateMark"
        />
        <aside-menu-container
          :has-dropdown-enabled="true"
          :menu-list="secondaryMenu.menu"
        />
      </div>
    </div>
  </aside>
</template>

<script>
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import moment from 'moment'
import AsideTools from '@/components/theme/AsideTools'
import AsideMenuContainer from '@/components/theme/AsideMenuContainer'
import UserAvatar from '@/components/theme/UserAvatar.vue'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'AsideMenu',
  components: {
    AsideTools,
    AsideMenuContainer,
    UserAvatar
  },
  props: {
    appName: {
      type: String,
      default: 'Ecobanka'
    },
    menu: {
      type: Array,
      default: () => []
    },
    menuBottom: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    hasSecondary() {
      return this.secondaryMenu && this.secondaryMenu.menu
    },
    hasMainCloseButton() {
      return !this.hasSecondary
    },
    year() {
      return moment().year()
    },
    ...mapState('layout', ['isAsideVisible', 'secondaryMenu']),
    ...mapState('user', ['rol'])
  },
  methods: {
    async logout() {
      let self = this
      await Auth.signOut().then(function() {
        AmplifyEventBus.$emit('authState', 'signedOut')
        self.$store.commit('user/UNSET_USER')
      })
    },
    menuClick(item) {
      // Note the comment above the function
      // It asks eslint to ignore declared, but unused variable (not good for production)
      // So, if you're not going to have some logic in here,
      // you may then safely replace menuClick(item) with menuClick() and leave the method empty
    },
    htmlClass(val) {
      let c = 'is-one-hero-layout'

      if (!val) this.$jbUtils.htmlAddClass(c)
      else this.$jbUtils.htmlRemoveClass(c)
    }
  },
  watch: {
    isAsideVisible(newVal) {
      this.htmlClass(newVal)
    }
  }
}
</script>

<style scoped></style>
